import { Component } from '@angular/core';

import { AttendeeHomeFiltersComponent } from '~/attendee/components/pages/home/filters/filters.component';

@Component({
  selector: 'app-attendee-home-filters-desktop',
  templateUrl: './filters-desktop.component.html',
})
export class AttendeeHomeFiltersDesktopComponent extends AttendeeHomeFiltersComponent {}
